import React from "react";
import { Box, Grid, Typography } from '@mui/material'
import MarkDownView from "../Home/Contents/MarkDownView";
import { AppData } from "../../Data/Models/AppData";
import ProjectCard from "../Home/Contents/ProjectCard";

const AdminProjects = (props:{data:AppData[], edit:(index:number)=>void, delete:(index:number)=>void}) => {

    
    const [open, setOpen] = React.useState(false);
    const [markDownData, setMarkDownData] = React.useState("");
    const data = props.data

    return (
        <Box>
            <Typography variant='h5' sx={{ margin: "20px" }}>
                Android Projects
            </Typography>
            <Grid container>
                {data && data.map((card, index) => {
                    return (
                        <React.Fragment key={index}>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <ProjectCard appData={card} readMoreClick={()=>{
                                    setOpen(true)
                                    setMarkDownData(card.markDown)
                                }} editClick={()=>{
                                    props.edit(index)
                                }} screenshotsClick={(index)=>{

                                }} deleteClick={()=>{
                                    props.delete(index)
                                }}/>
                            </Grid>
                        </React.Fragment>
                    );
                })}

            </Grid>
            <MarkDownView toggle={[open, setOpen]} markDownData={markDownData}/>
        </Box>
    )
}

export default AdminProjects
